import React from "react";
import "../../assets/fa-icons/css/fontawesome.css";
import "../../assets/fa-icons/css/sharp-solid.css";
import { FontStyles } from "../utils/font-styles.ts";
import { SectionHeader } from "./section-header.tsx";

const componentContainer = "flex flex-col w-full gap-5 md:gap-9 font-normal";

interface StepCardProps {
  title: string;
  icon: string;
  info: string;
}

const StepCard = (properties: StepCardProps) => {
  return (
    <div className={"flex flex-col gap-6.5 p-6.5 bg-cloud shadow-homepage-snippet lg:justify-between"}>
      <div className={"flex gap-3"}>
        <div className={"flex bg-legacy-primary p-2 rounded items-center justify-center h-[36px]"}>
          <i className={`text-neutral-white fa-solid fa-sharp ${properties.icon}`} />
        </div>
        <h3 className={`flex items-center text-north-sea lg:text-nowrap font-medium ${FontStyles.h5}`}>
          {properties.title}
        </h3>
      </div>
      <p className={`${FontStyles["body-l"]} text-slate`}>{properties.info}</p>
    </div>
  );
};

export const ValuationSteps: React.FC = () => {
  return (
    <div className={componentContainer}>
      <SectionHeader
        heading="How our valuation service works"
        headingAs={"h2"}
        subheading="Getting your property valued with an ESPC solicitor estate agent is simple and straightforward."
      />
      <div className={"flex flex-col lg:flex-row gap-5 md:gap-7"}>
        <StepCard
          title={"1. Complete the form"}
          icon={"fa-ballot-check fa-fw"}
          info={"Fill in your details and property information in our simple online form."}
        />
        <StepCard
          title={"2. Solicitor agent contact"}
          icon={"fa-message-lines fa-fw"}
          info={"An ESPC solicitor estate agent will contact you to discuss your property."}
        />
        <StepCard
          title={"3. Receive valuation"}
          icon={"fa-chart-mixed fa-fw"}
          info={"Get your professional property valuation and market advice from local experts."}
        />
      </div>
    </div>
  );
};
